var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20.8906V18.8906H6.75L6.35 18.5406C5.53333 17.724 4.93767 16.8366 4.563 15.8786C4.18833 14.9206 4.00067 13.9413 4 12.9406C4 11.0906 4.55433 9.44496 5.663 8.00362C6.77167 6.56229 8.21733 5.60796 10 5.14062V7.24062C8.8 7.67396 7.83333 8.41162 7.1 9.45362C6.36667 10.4956 6 11.658 6 12.9406C6 13.6906 6.14167 14.42 6.425 15.1286C6.70833 15.8373 7.15 16.4913 7.75 17.0906L8 17.3406V14.8906H10V20.8906H4ZM14 20.6406V18.5406C15.2 18.1073 16.1667 17.37 16.9 16.3286C17.6333 15.2873 18 14.1246 18 12.8406C18 12.0906 17.8583 11.3616 17.575 10.6536C17.2917 9.94562 16.85 9.29129 16.25 8.69063L16 8.44063V10.8906H14V4.89062H20V6.89062H17.25L17.65 7.24062C18.4667 8.05729 19.0627 8.94496 19.438 9.90362C19.8133 10.8623 20.0007 11.8413 20 12.8406C20 14.6906 19.446 16.3366 18.338 17.7786C17.23 19.2206 15.784 20.1746 14 20.6406Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.791748a3b2a404391dd5a441836435b3.svg";
export { ForwardRef as ReactComponent };